import { render, staticRenderFns } from "./GeekView.vue?vue&type=template&id=1c45e607&scoped=true"
import script from "./GeekView.vue?vue&type=script&lang=js"
export * from "./GeekView.vue?vue&type=script&lang=js"
import style0 from "./GeekView.vue?vue&type=style&index=0&id=1c45e607&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c45e607",
  null
  
)

export default component.exports